import React from 'react';
import _ from 'lodash';
import { FormControl, Typography } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { RequiredField } from '../others/RequiredField';
import { InfoField } from './InfoField';
import { CssTextField } from '../others/CssTextField';
import { useDynamicAction, useDynamicQuery } from '../../services/hooks';
import { constructDependsOnParams, handleShowOn } from '../../services/functions';

export const OnChangeCharField = props => {
  const { field, type, formik, getFieldCallback, updateDiscountsCallback } = props;
  const [val, setVal] = React.useState('');
  const action = useDynamicAction(
    field.depends_on,
    field.on_change,
    constructDependsOnParams(field.depends_on, field.name, formik.values
    ), val);
  const { query, data, loading } = useDynamicQuery(action);

  const handleChange = v => {
    formik.setFieldValue(field.name, v);
    if (field.on_change) {
      setVal(v);
      query(val);
    }
  };

  React.useEffect(() => {
    if (_.isObject(data)) {
      if (data.request_type === 'discount') {
        updateDiscountsCallback(data);
      }
    }
  }, [data]);

  return (
    <FormControl style={{ paddingBottom: 15, display: handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}
    fullWidth >
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} />
      </Typography>
      <DebounceInput
        debounceTimeout={500}
        element={CssTextField}
        type={type}
        name={field.name}
        label={field.placeholder}
        value={formik.values[field.name]}
        onChange={e => handleChange(e.target.value)}
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
        helperText={formik.touched[field.name] && formik.errors[field.name]}
        variant="outlined"

      />
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
